module.exports = __webpack_public_path__ + "static/media/Birds.a0d9ed3a.png";